import { Component, Input } from '@angular/core';
import { LogTypes } from 'src/app/core/enums/enums';
import { Operation } from 'src/app/core/models/operation-log.model';

@Component({
  selector: 'app-operation-content',
  templateUrl: './operation-content.component.html',
})
export class OperationContentComponent  {
  @Input() type: LogTypes;
  @Input() operation: Operation;
  optionType = LogTypes;

}
